import { ROUTINE_REACH_OUT_ACTION_TYPE } from '@littlebird/action-cards';
import { getSDK } from '@littlebird/sdk';
import { findLinkedActionCardIds } from '@littlebird/ui-utils';
import { observer } from 'mobx-react-lite';

import { YStack } from '@/components/ui/layout/layout';

import { useCanvasActionCardPlacements } from '../canvas-action-card-placement-context';

import { ActionCardItem } from './ActionCardItem';

/**
 * A routine run's chat stays hidden until the user reveals it, so its cards have no
 * assistant message to anchor to on the client. They are listed off the run's chat id
 * instead, ordered by creation rather than by the store's default tool-call order,
 * which only sorts within a step. Cards the report links inline are left to render
 * at that spot. The card a run reaches out with is left to Home, since the run view
 * shows that wait itself.
 */
export const ReportActionCards = observer(
  ({ chatId, renderedText }: { chatId: string; renderedText: string }) => {
    // Cards arrive by sync under the same MobX store, so React Compiler must not cache this filter
    'use no memo';
    const linkedCardIds = findLinkedActionCardIds(renderedText);
    const { canvasOnlyLocalIds, isLoading: isCanvasPlacementLoading } =
      useCanvasActionCardPlacements();
    const cards = getSDK()
      .stores.actionCards.getByChatId(chatId)
      .filter(
        (card) =>
          !linkedCardIds.has(card.localId) &&
          !canvasOnlyLocalIds.has(card.localId) &&
          card.actionType !== ROUTINE_REACH_OUT_ACTION_TYPE
      )
      .sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());

    if (isCanvasPlacementLoading || cards.length === 0) return null;

    return (
      <YStack className="mt-4 gap-3">
        {cards.map((card) => (
          <ActionCardItem card={card} surface="routine_report" key={card.id} />
        ))}
      </YStack>
    );
  }
);
